import {getLocalData, setLocalData} from '../../../utils/storage/storage';
import {keys} from '../../../api/keys';
import {tr} from '../../../translations';
import {showGlobalToast} from '../../../connected-components/toast/actions';
import {analyticsService} from '../../../utils/services/analytics';
import {
  ActionType,
  AnalyticsEvents,
  ArticleType,
  ToastType,
} from '../../../utils/enums';

export const toggleFavorite = async (news: any) => {
  try {
    const list = getLocalData(keys.FAVORITE);
    let favorites: any[] = [];
    if (list) {
      favorites = JSON.parse(list);
    }
    let isAdd = false;
    if (favorites.some(item => item.id === news.id)) {
      const idx = favorites.findIndex(item => item.id === news.id);
      favorites.splice(idx, 1);
      showGlobalToast({
        message: tr('favorite.removeFromFavorite'),
        type: ToastType.HELP,
      });
    } else {
      isAdd = true;
      favorites.push(news);
      showGlobalToast({
        message: tr('favorite.addToFavorite'),
        type: ToastType.HELP,
      });
    }
    const actionType = isAdd
      ? ActionType.ADD_TO_FAVORITES
      : ActionType.REMOVE_FROM_FAVORITES;
    const articleType = news?.isSummary
      ? ArticleType.SUMMARY
      : news?.isRecommendation
        ? ArticleType.RECOMMENDATIONS
        : ArticleType.NEWS;
    analyticsService?.logEvent(AnalyticsEvents.ToggleFavorite, {
      articleId: news?.id,
      articleTitle: news?.title,
      actionType,
      articleType,
    });
    setLocalData(keys.FAVORITE, JSON.stringify(favorites));
    return true;
  } catch (error) {
    showGlobalToast({message: tr('app.error'), type: ToastType.ERROR});
    return Promise.reject();
  }
};

export const getFavorites = async () => {
  try {
    const list = getLocalData(keys.FAVORITE);
    return list ? JSON.parse(list) : [];
  } catch (error) {
    return null;
  }
};

export const checkIfFavorite = async (news: any) => {
  try {
    const list = getLocalData(keys.FAVORITE);
    if (list) {
      const jsonList = JSON.parse(list);
      return jsonList.some((item: any) => {
        return item?.id === news?.id;
      });
    }
    return false;
  } catch (error) {
    return false;
  }
};
